export const ARROW_TEXT_MOVE_STEP = 1;
export const ARROW_TEXT_MOVE_STEP_LARGE = 10;
export const TEXT_DUPLICATE_STEP = 10;
export const MAX_RECENT_FONTS = 5;

export const OUTLINE_STROKE_WIDTH = 32;
export const TEXT_DEFAULT_OPACITY_OUTLINE = 100;
export const TEXT_DEFAULT_OUTLINE_COLOR = { r: 255, g: 255, b: 255 };
export const TEXT_DEFAULT_SHADOW_COLOR = { r: 0, g: 0, b: 0 };
export const SHAPE_DEFAULT_OUTLINE_COLOR = { r: 255, g: 255, b: 255 };
